import { render, staticRenderFns } from "./WebDelivery.vue?vue&type=template&id=18770408&scoped=true&lang=pug"
import script from "./WebDelivery.vue?vue&type=script&lang=js"
export * from "./WebDelivery.vue?vue&type=script&lang=js"
import style0 from "./WebDelivery.vue?vue&type=style&index=0&id=18770408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18770408",
  null
  
)

export default component.exports